/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum HelpTypeSite {
  HelpLawyer = 'HELP_LAWYER',
  AskRequest = 'ASK_REQUEST',
  AskNewsSubscribe = 'ASK_NEWS_SUBSCRIBE',
  FreeConsultation = 'FREE_CONSULTATION',
  OrderCall = 'ORDER_CALL',
  BecomePartner = 'BECOME_PARTNER',
  FindOutTerms = 'FIND_OUT_TERMS',
  Calculator = 'CALCULATOR',
  SelectTariff = 'SELECT_TARIFF',
  GetApplicationDraft = 'GET_APPLICATION_DRAFT',
}

export function instanceOfHelpTypeSite(value: any): boolean {
  for (const key in HelpTypeSite) {
    if (Object.prototype.hasOwnProperty.call(HelpTypeSite, key)) {
      if (HelpTypeSite[key as keyof typeof HelpTypeSite] === value) {
        return true
      }
    }
  }
  return false
}

export function HelpTypeSiteFromJSON(json: any): HelpTypeSite {
  return HelpTypeSiteFromJSONTyped(json, false)
}

export function HelpTypeSiteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpTypeSite {
  return json as HelpTypeSite
}

export function HelpTypeSiteToJSON(value?: HelpTypeSite | null): any {
  return value as any
}
